import { cn } from "@/lib/cn";
import type { LucideIcon } from "lucide-react";
import type React from "react";

export interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  message: string;
  action?: React.ReactNode;
  className?: string;
}

export function EmptyState({ icon: Icon, title, message, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-3 py-12 text-center",
        className,
      )}
    >
      <div className="rounded-full bg-accent-light p-4 text-accent">
        <Icon size={32} strokeWidth={2} />
      </div>
      <h3 className="text-lg font-semibold text-text">{title}</h3>
      <p className="max-w-xs text-sm text-text-muted leading-relaxed">{message}</p>
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
